import * as TK from 'components/PDP/Details/components/ContinueButton/translations/continue-button.locale.constants';

export const continueButtonCommonLocale = {
  [TK.PRODUCT_CONTINUE_BUTTON]: 'Continue',
  [TK.PRODUCT_CONTINUE_BUTTON_ARIAL_LOADING]: 'Loading...',
};
